export function swipeHandlers(onBack) {
  let startX = 0;
  let startY = 0;
  return {
    onTouchStart: (e) => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    },
    onTouchEnd: (e) => {
      const dx = e.changedTouches[0].clientX - startX;
      const dy = Math.abs(e.changedTouches[0].clientY - startY);
      if (startX < 40 && dx > 60 && dy < 80) onBack();
    },
  };
}
